import script from "./OnboardingSlide2.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingSlide2.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingSlide2.vue?vue&type=style&index=0&id=497f466b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497f466b"]])

export default __exports__